<template lang='pug'>
div(class="modal" role="dialog" tabindex="-1" style="display:block;" aria-hidden="true")
  div(class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document")
    div(class="modal-content")
      div(class="modal-header")
        SectionTitle(sectionText="回報錯誤")
      div(class="modal-body")
        .popup-item
          textarea(:class="alert.content.textarea" rows=4 placeholder="請輸入正確闢謠解釋" @input="checkActive" v-model="params.content" )
          .popup-alertText(v-if="alert.content.alertText") 已達字數上限
          div(:class="alert.content.counter")
            span.popup-remainingCounter {{ params.content.length }}
            span.popup-limitCounter {{ contentLimit }}
        .popup-item.popup-item--wrapColumn
          span.popup-text 查核結果
          Dropdown(:id="'report-error-' + commentId"
            placeholder="請選擇"
            :selectText='feedbackType'
            innerTextClass="popup-option-innerText"
            :infos="infos" optionClass="popup-option"
            @selectDropdown="selectDropdown"
          )
        .popup-item
          vue-recaptcha(
            :sitekey="$store.state.recaptchaSiteKey"
            :loadRecaptchaScript="true"
            @verify="onCaptchaVerified"
            @expired="onCaptchaExpired"
          )
      div(class="modal-footer")
        PopupButtonsOnBottom(:isActive="isActive" :isScrollablePopup='true' :isSingleButton='false' @send="send" @cancel="closePopup")
</template>

<script>
import SectionTitle from '@/components/modules/section_title/section_title.vue'
import Dropdown from '@/components/modules/dropdown.vue'
import PopupButtonsOnBottom from '@/components/popup/popup-buttons-on-bottom.vue'
import VueRecaptcha from 'vue-recaptcha'
import { lockBody, unlockBody, getRouteByParam, checkPopupAlert } from '@/plugins/tool.js'
import $ from 'jquery'
import qs from 'qs'

export default {
  components: {
    SectionTitle,
    Dropdown,
    PopupButtonsOnBottom,
    VueRecaptcha
  },
  props: {
    commentId: Number
  },
  created() {
    this.getInfo()
  },
  mounted() {
    lockBody()
  },
  data() {
    return {
      infos: [],
      feedbackTypeId: null,
      feedbackType: '',
      params: {
        commentId: this.commentId,
        content: ""
      },
      contentLimit: 200,
      isActive: false,
      recaptchaResponse: "",
      recaptchaClicked: false,
      alert: {
        content: {
          textarea: "popup-textarea",
          counter: "popup-counter",
          alertText: false
        }
      }
    }
  },
  methods: {
    async getInfo() {
      let route = this.$store.state.URLs.api + this.$store.state.routes.feedbackTypes
      let result = await this.$axios.get(route)
      this.infos = result.data;
      this.infos.forEach(info => {
        info.name = info[this.$store.state.lang]
      })
    },
    checkActive() {
      this.alert.content = checkPopupAlert(this.params.content.length > this.contentLimit, this.alert.content)
      if (this.params.content &&
          this.params.content.length <= this.contentLimit &&
          this.params.feedbackTypeId != null &&
          this.recaptchaClicked)
        this.isActive = true
      else this.isActive = false
    },
    closePopup() {
      unlockBody()
      this.$emit("closePopup")
    },
    selectDropdown(event) {
      this.params.feedbackTypeId = event.id
      this.feedbackType = event.name
      this.checkActive()
    },
    async send() {
      if (!this.isActive)
        return
      this.sendData()
    },
    async sendData() {
      this.params.content = $(".popup-textarea").val();
      this.params["g-recaptcha-response"] = this.recaptchaResponse
      if (this.params.content == "") return
      let route = "";
      let headers = {}
      let body = {}
      const token = localStorage.getItem(this.$store.state.storageKeys.token)
      const identity = localStorage.getItem(this.$store.state.storageKeys.identity)
      if (identity === 'users') {
        route += this.$store.state.URLs.api + this.$store.state.routes.postFeedbacks
        headers['Authorization'] = "Bearer " + token
        route = getRouteByParam(this.params, route)
      }
      else {
        route += this.$store.state.URLs.apiPartner + this.$store.state.routes.postFeedbacks
        headers['X-Line-Biz-Session'] = token
        headers['Content-Type'] = 'application/x-www-form-urlencoded'
        body = JSON.parse(JSON.stringify(this.params))
      }
      this.$axios.post(route, qs.stringify(body), {
        headers: headers
      })
      .then(() => {
        this.closePopup()
        this.$emit("isSuccess")
      })
      .catch(() => {
        this.closePopup()
        this.$emit("isError")
      })
    },
    onCaptchaVerified(response) {
      this.recaptchaResponse = response
      this.recaptchaClicked = true
      this.checkActive()
    },
    onCaptchaExpired(response) {
      this.recaptchaResponse = response
      this.recaptchaClicked = false
      this.checkActive()
    }
  }
}
</script>
<style scoped src="../../assets/koromo_min.css">
</style>